/**
 * Created by hernanherreros on 2019-05-28
 */

import * as React from 'react'
import withWizardProps, { WizardProps } from '../../../wrappers/withWizardParams'
import { RouteComponentProps, withRouter } from 'react-router'
import { flowRight } from 'lodash'
import StepItem from './StepItem'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'
import { RouterItem } from '../../../config/router.config'
import withCongress, { ComponentProps } from '../../../providers/Congress/withCongress'
import { getRouteConfig, getSteps } from '../../../helpers/routes'


interface Props extends RouteComponentProps, WizardProps, ComponentProps {
  currentStep: string;
}

class Steps extends React.Component<Props> {
  render() {
    return (
      <Container mt={4}>
        {this.renderSteps()}
      </Container>
    )
  }

  renderSteps () {
    const { currentStep, congress } = this.props
    const steps = getSteps(congress.Slug)

    const routerConfig = steps.map(step => {
      return { ...getRouteConfig(congress.Slug, step  ) }
    })

    const activeStepIndex = routerConfig.findIndex(i => i.slug === currentStep) + 1

    return routerConfig.map((route: RouterItem, index, routes: RouterItem[]) => {
      return (
        <React.Fragment key={index}>
          <StepItem number={route.number} active={route.number <= activeStepIndex} step={route}/>
        </React.Fragment>
      )
    })
  }
}

const Container = styled.div<SpaceProps>`
  display: flex;
  
    @media screen and (max-width: 40em) {
      flex-direction: column;
    }
  
  ${space}
`

const Arrow = styled.img`
  @media screen and (max-width: 40em) {
    display: none;
  }
`

export default flowRight([withRouter, withWizardProps, withCongress])(Steps)
